<template>
    <el-dialog
        append-to-body
        class="send-now-modal"
        :visible.sync="showLocal"
        :close-on-click-modal="false"
        width="30vw">
        <div slot="title">
            Push To EMR
        </div>
        <div class="emr-content">
            <template v-if="emrData.hasAutoPushEnabled">
            <p class="attention">Attention!</p>
                <p class="subheading">Auto Push to EMR is enabled for this Questionnaire, are you 
                    sure you want to push notes to <b> {{ emrData.emrTitle }}?</b>
                </p>
            </template>
            <p v-else class="subheading">Are you sure you want to push notes to <b> {{ emrData.emrTitle }}?</b>
            </p>
            <span class="emr-type" v-if="emrData.pushType === 'questionnaire'">
                <h5>Questionnaire</h5>
                <span class="emr-title">
                    {{ emrData.title }}
                    &middot;
                    <span class="emr-date">
                        {{ emrData.displayTime }}
                    </span>
                </span>
            </span>
            <span class="emr-type" v-if="emrData.pushType === 'schedule'">
                <h5>Event</h5>
                <span class="emr-title">
                    {{ getContentKey('event', emrData.scheduleId, 'name') }}
                    &middot;
                    <span class="emr-date">
                        {{ emrData.displayTime }}
                    </span>
                </span>
            </span>
        </div>
        <div slot="footer">
            <el-button @click="showLocal = false"  size="large">Cancel</el-button>
            <LoadingButton
                type="primary"
                :loading="loading"
                :disabled="loading"
                :loaded="loaded"
                @click="saveNoteQuestionnaire">
                Confirm
            </LoadingButton>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import LoadingButton from '@/module/component/LoadingButton'

export default {
    name: 'emr-dialog',
    props: ["emrData", "dialogShow", "patient", "savedCharts"],

    data() {
        return {
            loading: false,
            disabled: false,
            loaded: false,
            showLocal: this.dialogShow
        }
    },

    watch: {
        showLocal(newValue) {
            if(newValue === false)
                this.$emit('close-confirmation')
        }
    },

    methods : {
        ...mapActions('provider', ['pushNoteCategory', 'pushNewNoteCategory']),
        saveNoteQuestionnaire() {
            const emrData = this.emrData
            if(this.doesNoteSavedVersionExists) {
                console.log('saveNoteQuestionnaireNewVersion')
                this.saveNoteQuestionnaireNewVersion()
                return
            }
            const queryData = {
                schedule: emrData.schedule,
                
                id: this.patient.id,
                provider: emrData.provider,
                emrs: [{
                    emr_category: emrData.emrId,
                }]
            }
            if(emrData.pushType === 'questionnaire') {
                queryData.emrs[0].questionnaire_notes = {
                    [emrData.id] : emrData.result.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                }
                queryData.emrs[0].questions_responses = emrData.questions_responses
                queryData.emrs[0].note = {
                    [`${emrData.questionnaire_id}:${emrData.id}`]: emrData.result.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                }
            }
                
            else if (emrData.pushType = 'schedule') {
                queryData.emrs[0].questionnaire_notes = emrData.note.reduce((acc, noteObj) => {
                    acc[noteObj.id] = noteObj.result.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                    return acc
                }, {})
                queryData.emrs[0].questions_responses = emrData.note.reduce((acc, respObj) => ({...respObj.questions_responses, ...acc}), {})
                queryData.emrs[0].note = emrData.note.reduce((acc, noteObj) => {
                    const noteId = `${noteObj.questionnaire_id}:${noteObj.id}`
                    acc[noteId] = noteObj.result.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                    return acc
                }, {})
            }
                
            this.loading = true
            this.pushNoteCategory(queryData)
                .then((response) => {
                    this.showLocal = false
                    this.$message({
                        message: response.description,
                        type: response.success ? 'success' : 'error'
                    })
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error(error.description)
                }).finally((_) => this.loading = false)

        },
        saveNoteQuestionnaireNewVersion() {
            const emrData = this.emrData
            const query = {
                id: this.patient.id,
                provider: emrData.provider,
                emr_category: emrData.emrId,
                questionnaire: [emrData.id]
            }
            this.loading = true  
            this.pushNewNoteCategory(query)
                .then((response) => {
                    this.showLocal = false
                    this.$message({
                        message: `Pushed to ${emrData.emrTitle}`,
                        type: 'success'
                    })
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error("Problem pushing to EMR")
                }).finally((_) => this.loading = false)
        }
    },

    computed: {
        ...mapGetters('content', ['getContentKey']),
        hasBeenPushedBefore() {
            if (this.emrData && this.emrData.emrCategory && this.emrData.emrCategory.find(category => category.id === this.emrData.emrId).last_pushed.length)
                return true
            return false
        },
        /**
         * Check if the note has a saved version already available to
         * update, by checking `savedCharts`
         */
        doesNoteSavedVersionExists() {
            return this.savedCharts.length > 0
        },
    },

    components: {
        LoadingButton
    }
}
</script>

<style lang="scss">
.emr-content {
    padding-top: 15px;
    font-size: 16px;

    .subheading {
        line-height: 20px;
        word-break: normal;
        white-space: normal;
    }

    p {
        line-height: 20px;
        margin-bottom: 5px;
    }
    
    .attention {
        font-weight: 700;
        color: #DA4E4E;
    }
    .emr-type {
        padding-top: 16px;
        display: block;
        h5 {
            display: inline-block;
            margin: 0;
            color: #828282;
            font-size: 16px;
            font-weight: normal;
        }
        .emr-title {
            margin-top: 5px;
            line-height: 20px;
            padding: 8px;
            display: inline-block;
            background-color: #FAF5FC;
            color: #833E93;
            font-size: 14px;
            font-weight: 600;
        }
        .emr-date {
            font-size: 12px;
            font-weight: 400;
        }
    }
}
</style>